import { ERROR } from "../actions/types";

export const getError = ({ response, dispatch }) => {
  if (!response.ok) {
    dispatch({ type: ERROR, payload: response });
    return;
  }
};